import * as Yup from 'yup'

export const updateBankingGroupRatingValidationSchema = Yup.object().shape({
  shortRating: Yup.string().required(),
  longRating: Yup.string().required(),
  startDate: Yup.date().required(),
})
